import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { SmsTerms } from './pages/SmsTerms';
import { Contact } from './pages/Contact';
export function App() {
  useEffect(() => {
    document.title = 'VSC Clothing';
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('og:title', 'VSC Clothing');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="shop" element={<Shop data-id="element-7" />} data-id="element-6" />
          <Route path="product/:id" element={<ProductDetail data-id="element-9" />} data-id="element-8" />
          <Route path="checkout" element={<Checkout data-id="element-11" />} data-id="element-10" />
          <Route path="order-confirmation" element={<OrderConfirmation data-id="element-13" />} data-id="element-12" />
          <Route path="privacy" element={<Privacy data-id="element-15" />} data-id="element-14" />
          <Route path="terms" element={<Terms data-id="element-17" />} data-id="element-16" />
          <Route path="sms-terms" element={<SmsTerms data-id="element-19" />} data-id="element-18" />
          <Route path="contact" element={<Contact data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </BrowserRouter>;
}